var _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _rect3, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPB1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.1",
    points: "271 373 366 373 366 383.95 393 383.95 393 535 271 535 271 373"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.1.2",
    x: 80.7,
    y: 373,
    width: 186.36,
    height: 162
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.3",
    points: "93 201 267 201 267 331.88 166 331.88 166 368 93 368 93 201"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.4",
    points: "271 188 393 188 393 331.88 298 331.88 298 321 271 321 271 188"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.5",
    points: "396.64 188 518.87 188 518.87 320.78 492 320.78 492 332 396.64 332 396.64 188"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.6",
    points: "523.3 188 645 188 645 332 550 332 550 321 523.3 321 523.3 188"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.7",
    points: "650 170 771 170 771 321 744 321 744 332 649 332 649 170 650 170"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.8",
    points: "775.32 170 911 170 911 303 898 303 898 368 775.32 368 775.32 170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.1.9",
    x: 747,
    y: 373,
    width: 151,
    height: 131
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.1.10",
    x: 649,
    y: 373,
    width: 93,
    height: 131
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.1.11",
    points: "550.03 373 645 373 645 516 523 516 523 384.13 550 384.13 550.03 373"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDk5MCA3MjAiPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjEuMSIgcG9pbnRzPSIyNzEgMzczIDM2NiAzNzMgMzY2IDM4My45NSAzOTMgMzgzLjk1IDM5MyA1MzUgMjcxIDUzNSAyNzEgMzczIi8+CgoKICAgIDxyZWN0IGRhdGEtaWQ9IkIuMS4yIiB4PSI4MC43IiB5PSIzNzMiIHdpZHRoPSIxODYuMzYiIGhlaWdodD0iMTYyIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMS4zIiBwb2ludHM9IjkzIDIwMSAyNjcgMjAxIDI2NyAzMzEuODggMTY2IDMzMS44OCAxNjYgMzY4IDkzIDM2OCA5MyAyMDEiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4xLjQiIHBvaW50cz0iMjcxIDE4OCAzOTMgMTg4IDM5MyAzMzEuODggMjk4IDMzMS44OCAyOTggMzIxIDI3MSAzMjEgMjcxIDE4OCIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjEuNSIgcG9pbnRzPSIzOTYuNjQgMTg4IDUxOC44NyAxODggNTE4Ljg3IDMyMC43OCA0OTIgMzIwLjc4IDQ5MiAzMzIgMzk2LjY0IDMzMiAzOTYuNjQgMTg4Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMS42IiBwb2ludHM9IjUyMy4zIDE4OCA2NDUgMTg4IDY0NSAzMzIgNTUwIDMzMiA1NTAgMzIxIDUyMy4zIDMyMSA1MjMuMyAxODgiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi4xLjciIHBvaW50cz0iNjUwIDE3MCA3NzEgMTcwIDc3MSAzMjEgNzQ0IDMyMSA3NDQgMzMyIDY0OSAzMzIgNjQ5IDE3MCA2NTAgMTcwIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMS44IiBwb2ludHM9Ijc3NS4zMiAxNzAgOTExIDE3MCA5MTEgMzAzIDg5OCAzMDMgODk4IDM2OCA3NzUuMzIgMzY4IDc3NS4zMiAxNzAiLz4KCgogICAgPHJlY3QgZGF0YS1pZD0iQi4xLjkiIHg9Ijc0NyIgeT0iMzczIiB3aWR0aD0iMTUxIiBoZWlnaHQ9IjEzMSIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjEuMTAiIHg9IjY0OSIgeT0iMzczIiB3aWR0aD0iOTMiIGhlaWdodD0iMTMxIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuMS4xMSIgcG9pbnRzPSI1NTAuMDMgMzczIDY0NSAzNzMgNjQ1IDUxNiA1MjMgNTE2IDUyMyAzODQuMTMgNTUwIDM4NC4xMyA1NTAuMDMgMzczIi8+Cgo8L3N2Zz4=";
export { SvgPB1 as ReactComponent };